export default __webpack_public_path__ + "static/base-lite-6-a10e456b75142a6bb5d23d7b06404495.jpg";